export default __webpack_public_path__ + "static/media/place-holder.80fbd424.jpg";